/* countdown-timer.js */
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initTimer(el) {
    if (el.dataset.countdownInitialized) return;
    el.dataset.countdownInitialized = 'true';

    const endDateRaw = el.dataset.endDate;
    const repeatDaily = el.dataset.repeatDaily === 'true';
    const expiredText = el.dataset.expiredText || 'Sale has ended';

    const daysEl = el.querySelector('[data-countdown-days]');
    const hoursEl = el.querySelector('[data-countdown-hours]');
    const minutesEl = el.querySelector('[data-countdown-minutes]');
    const secondsEl = el.querySelector('[data-countdown-seconds]');
    const digitsWrap = el.querySelector('[data-countdown-digits]');
    const expiredWrap = el.querySelector('[data-countdown-expired]');

    // Parse "YYYY-MM-DD HH:MM" as a local time.
    function parseEndDate(raw) {
      const cleaned = raw.trim().replace(' ', 'T');
      const d = new Date(cleaned);
      return isNaN(d.getTime()) ? null : d;
    }

    let endDate = parseEndDate(endDateRaw);
    if (!endDate) {
      el.hidden = true;
      return;
    }

    function getTarget() {
      if (!repeatDaily) return endDate;

      // Repeat daily: use only the end date's time-of-day, applied to today (or tomorrow if already passed today).
      const now = new Date();
      const target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endDate.getHours(), endDate.getMinutes(), 0, 0);
      if (target.getTime() <= now.getTime()) {
        target.setDate(target.getDate() + 1);
      }
      return target;
    }

    function tick() {
      const now = new Date().getTime();
      const target = getTarget();
      const diff = target.getTime() - now;

      if (diff <= 0 && !repeatDaily) {
        digitsWrap.hidden = true;
        if (expiredWrap) {
          expiredWrap.hidden = false;
          expiredWrap.textContent = expiredText;
        }
        clearInterval(intervalId);
        return;
      }

      const totalSeconds = Math.max(0, Math.floor(diff / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    const intervalId = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-countdown-timer]').forEach(initTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

/* sticky-add-to-cart.js */
(function () {
  'use strict';

  function initStickyAtc(bar) {
    if (bar.dataset.stickyInitialized) return;
    bar.dataset.stickyInitialized = 'true';

    const sectionId = bar.dataset.sectionId;
    const mainButton = document.getElementById('ProductSubmitButton-' + sectionId);

    if (!mainButton) {
      bar.hidden = true;
      return;
    }

    function toggleVisibility() {
      const rect = mainButton.getBoundingClientRect();
      const scrolledPast = rect.bottom < 0;
      bar.hidden = !scrolledPast;
    }

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    window.addEventListener('resize', toggleVisibility);
    toggleVisibility();

    // Keep price in sync with variant changes on the main form.
    const priceEl = bar.querySelector('[data-sticky-atc-price]');
    const mainPriceEl = document.querySelector(
      '#price-' + sectionId + ', .price'
    );
    if (priceEl && mainPriceEl) {
      const observer = new MutationObserver(() => {
        const text = mainPriceEl.querySelector('.price-item--regular, .price-item')?.textContent?.trim();
        if (text) priceEl.textContent = text;
      });
      observer.observe(mainPriceEl, { childList: true, subtree: true, characterData: true });
    }

    // Clicking the sticky button submits the real product form (same as the
    // in-page Add to Cart button) so it goes through Dawn's normal cart logic
    // (cart drawer / cart page, stock validation, etc).
    const buyBtn = bar.querySelector('[data-sticky-atc-buy]');
    if (buyBtn) {
      buyBtn.addEventListener('click', () => {
        if (mainButton.disabled) return;
        mainButton.click();
      });
      if (mainButton.disabled) buyBtn.disabled = true;

      // Keep sold-out state in sync (e.g. after a variant change).
      const disabledObserver = new MutationObserver(() => {
        buyBtn.disabled = mainButton.disabled;
      });
      disabledObserver.observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

/* social-proof.js */
(function () {
  'use strict';

  const NAMES = [
    'Ahmed', 'Fatima', 'Ali', 'Sana', 'Bilal', 'Ayesha', 'Usman', 'Hina',
    'Hassan', 'Mehwish', 'Zain', 'Rabia', 'Imran', 'Nida', 'Faisal', 'Sadia',
    'Kashif', 'Amna', 'Tariq', 'Saba'
  ];

  const CITIES = [
    'Lahore', 'Karachi', 'Islamabad', 'Multan', 'Gujranwala', 'Faisalabad',
    'Rawalpindi', 'Peshawar', 'Sialkot', 'Bahawalpur', 'Sargodha', 'Sukkur'
  ];

  function randomFrom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function initSoldBadge() {
    const badge = document.querySelector('[data-sold-count-badge]');
    if (!badge || badge.dataset.initialized) return;
    badge.dataset.initialized = 'true';

    const min = parseInt(badge.dataset.min, 10) || 8;
    const max = parseInt(badge.dataset.max, 10) || 20;
    const textEl = badge.querySelector('[data-sold-count-text]');
    const template = (window.socialProofStrings && window.socialProofStrings.soldRecently) || '{count} sold in last 1 hour';

    function render() {
      const count = randomInt(min, max);
      textEl.textContent = template.replace('{count}', count);
    }

    render();
    // Gently vary the number every ~45-90s so it doesn't look static, without being obviously fake.
    setInterval(render, randomInt(45000, 90000));
  }

  function initJustBoughtToast() {
    const toast = document.querySelector('[data-just-bought-toast]');
    if (!toast || toast.dataset.initialized) return;
    toast.dataset.initialized = 'true';

    const textEl = toast.querySelector('[data-just-bought-text]');
    const closeBtn = toast.querySelector('[data-just-bought-close]');
    const template = (window.socialProofStrings && window.socialProofStrings.justBought) || '{name} from {city} just bought this item!';

    let dismissed = false;
    let hideTimeout;

    closeBtn.addEventListener('click', () => {
      dismissed = true;
      toast.hidden = true;
    });

    function showToast() {
      if (dismissed) return;
      const name = randomFrom(NAMES);
      const city = randomFrom(CITIES);
      textEl.textContent = template.replace('{name}', name).replace('{city}', city);
      toast.hidden = false;
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        toast.hidden = true;
      }, 6000);
    }

    // First toast appears after a short delay, then repeats on a random interval.
    setTimeout(function loop() {
      showToast();
      setTimeout(loop, randomInt(20000, 40000));
    }, randomInt(4000, 8000));
  }

  function initAll() {
    initSoldBadge();
    initJustBoughtToast();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

/* recently-viewed.js */
(function () {
  'use strict';

  const STORAGE_KEY = 'dk_recently_viewed';
  const MAX_ITEMS = 12;

  function getViewed() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveViewed(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* localStorage unavailable, ignore */
    }
  }

  function trackCurrentProduct() {
    const dataEl = document.querySelector('[data-recently-viewed-track]');
    if (!dataEl) return;

    let product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    let list = getViewed();
    list = list.filter((p) => p.handle !== product.handle);
    list.unshift(product);
    saveViewed(list);
  }

  function renderRecentlyViewed() {
    const container = document.querySelector('[data-recently-viewed-list]');
    if (!container) return;

    const currentHandle = container.dataset.currentHandle || '';
    const list = getViewed().filter((p) => p.handle !== currentHandle);

    if (list.length === 0) {
      const section = container.closest('[data-recently-viewed-section]');
      if (section) section.hidden = true;
      return;
    }

    container.innerHTML = list
      .slice(0, 8)
      .map(
        (p) => `
        <a href="${p.url}" class="recently-viewed__card">
          <img src="${p.image}" alt="${escapeHtml(p.title)}" width="150" height="150" loading="lazy">
          <span class="recently-viewed__title">${escapeHtml(p.title)}</span>
          <span class="recently-viewed__price">${p.price}</span>
        </a>`
      )
      .join('');
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function init() {
    trackCurrentProduct();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
